<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ftit"><a id="page_vi"></a>Introduction</h2>
<p class="noindent">The Battle of Britain is an epic story. As a result, not least because of the need for expensive aeroplanes, it is a difficult one to translate to cinema. Writing this book and mapping the development of how the Battle of Britain has appeared in British cinema over the years, and considering the various influencing facts, has been an interesting, and I hope useful, exercise, especially the detailed ‘reading’ of certain key films.</p>
<p class="indent">It is perhaps surprising, though, that overall and with the exception of Guy Hamilton’s 1969 <em class="italic">Battle of Britain</em> film, the summer of 1940, certainly in respect of the overall story, has been poorly served by cinema. Also, considering the importance of ‘The Finest Hour’ to the British national identity, it has been featured infrequently in television drama – Matthew Whiteman’s excellent BBC2 docudrama <em class="italic">First Light</em> being the most recent, produced for the seventieth anniversary in 2010. It is doubtful whether this will change now, and so <em class="italic">Battle of Britain</em> and <em class="italic">First Light</em> may well represent the high points of the Battle of Britain on film.</p>
<p class="indent">While academic historians remain vexed and continue debating the merits or otherwise of history on film, there is an argument that unfaithful though some ‘historical’ films are to the actual facts, they can be of value through igniting interest in the viewer and inspiring a need to know more. All kinds of benefits for the historical record could arise from such a circumstance. Having first watched <em class="italic">Battle of Britain</em> as an 8-year-old schoolboy upon release in 1969, were that not the case, I would not be writing this …</p>
<p class="fright"><em class="italic">Dilip Sarkar MBE, FRHistS, 2021</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Introduction.vue?76843748